import React, { useState } from "react";
import { createSearchParams, useNavigate, useSearchParams } from "react-router";
import { routeCodes } from "../../config/routes";
import { requiresMotion } from "../../utilities/games";
import { getString } from "../../utilities";
import Modal from "../global/modal";
import ModalClose from "../global/modalClose";
import Arrow from "../../../assets/svg/arrowRight.svg";
import GameScreenshots from "./GameScreenshots";

export default function MobileContent({ game, isArcademics, canPlayGame, publicModalToggle }) {
  const navigate = useNavigate();

  const [modal, setModal] = useState(false);
  const [searchParams] = useSearchParams();
  const gameVersionOverride = searchParams.get("gameVersion");

  const ssClickHandler = async () => {
    if (game.mobileActive) {
      // game is mobile ready
      if (canPlayGame) {
        if (requiresMotion(game?.shortname)) {
          // devicemotion requests can only be granted in response to a click
          await DeviceMotionEvent?.requestPermission();
        }

        // pass media url to game in state
        navigate(
          {
            pathname: `${routeCodes.MOBILEGAMES}${game.localeShortname || game.shortname}`,
            ...(gameVersionOverride && { search: createSearchParams({ gameVersion: gameVersionOverride }).toString() }),
          },
          {
            state: { game, arcademics: isArcademics },
          },
        );
      } else {
        publicModalToggle();
      }
    } else {
      setModal(true);
    }
  };

  return (
    <>
      <GameScreenshots game={game} clickHandler={ssClickHandler} />

      <Modal doShow={modal} closeOnEscape={() => setModal((prev) => !prev)}>
        <ModalClose close={() => setModal((prev) => !prev)} />
        <div className="modal-content-header">{getString("game.mobile.notAvailable", { html: true })}</div>

        <div style={{ marginBottom: "1rem" }}>
          <button
            type="button"
            onClick={() => {
              navigate(routeCodes.GAMES);
            }}
            className="button-flat-color pt-green round auto"
          >
            {getString("game.mobile.find")}
            <Arrow className="inline-arrow" />
          </button>
        </div>
        <h4>{getString("game.mobile.play")}</h4>
      </Modal>
    </>
  );
}
